import { FunctionComponent, memo, useEffect } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { IYearGroup } from "./IyearGroup";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import TextInputFieldC from "../../Components/TextInput/TextInputFieldC";
import { useAppDispatch } from "../../Redux/Store/Hooks";
import { addyearGroup } from "../../Redux/Slices/yearGroup/AddyearGroupSlice";
import { EdityearGroup } from "../../Redux/Slices/yearGroup/EdityearGroupSlice";
import Select from "../../Components/Select/AutoComplete";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import TextAreaInputField from "../../Components/TextAreaInput/TextAreaInputField";

interface yearGroupFormProps {
  formRef: React.RefObject<HTMLFormElement>;
  initialValues: IYearGroup;
  setInitialValues: React.Dispatch<React.SetStateAction<IYearGroup>>;
}

const YearGroupForm: FunctionComponent<yearGroupFormProps> = (props) => {
  const dispatch = useAppDispatch();

  const userSchema = z.object({
    id: z.number().optional(),
    year_group: z
      .string({ message: "Please enter Year group" })
      .min(1, { message: "Please enter Year group" })
      .max(20, { message: "Year group cannot exceed 20 characters" })
      .regex(/^[a-zA-Z0-9_ ]+$/, {
        message:
          "Year group can only contain letters, numbers, spaces, and underscores",
      }),

    status: z.boolean({
      message: "Please select the status",
    }),
  });
  const methods = useForm<IYearGroup>({
    defaultValues: {
      ...props.initialValues,
      status: props.initialValues.id ? props.initialValues.status : true,
    },

    resolver: zodResolver(userSchema),
    mode: "onChange",
  });

  const onSubmit: SubmitHandler<IYearGroup> = (val) => {
    console.log("Form submitted with values:", val); // Log the submitted form values
    if (val.id) {
      dispatch(EdityearGroup(val));
    } else {
      dispatch(addyearGroup(val));
    }
  };

  useEffect(() => {
    return () => {
      props.setInitialValues({});
    };
  }, [dispatch, props]);

  // Status list
  const yearGroupSatus = [
    {
      label: "Active",
      value: true,
    },

    {
      label: "Inactive",
      value: false,
    },
  ];

  return (
    <FormProvider {...methods}>
      <form
        ref={props.formRef}
        onSubmit={methods.handleSubmit(onSubmit)}
        className="form_content"
      >
        <TextInputFieldC name="year_group" label="Year Group" type="text" />

        <Select
          name="status"
          label="Status"
          options={yearGroupSatus}
          value={
            yearGroupSatus?.find(
              (role) => role.value === methods.getValues("status")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("status", val?.value, { shouldValidate: true });
          }}
        />
      </form>
    </FormProvider>
  );
};

export default memo(YearGroupForm);
